import { Action } from '@ngrx/store';
import { ActionType, isAction } from '../../../../../shared/state/index.state';
import { SatelliteSurveillance } from '../admin-satellite-surveillance.model';
import { SatelliteSurveillanceActions } from './satellite-surveillance.actions';
import { SatelliteSurveillanceState } from './satellite-surveillance.state';

const initialSatelliteSurveillanceValue: SatelliteSurveillanceState = {
    satelliteSurveillance: [{ // TODO: rename to "satellites" as list inside the satelliteSurveillance state
        autoremindAccount: '',
        userId: 0,
        lastCheckin: '',
        satelliteName: '',
        schedulerState: '',
        satelliteVersion: '',
        satelliteId: 0,
        userStatus: '',
        moduleType: '',
        otherUsersDatasourcesCount: 0,
        totalDatasourcesCount: 0,
        typeOfCheck: '',
        howLongAgoLastCheckIn: 0,
        lastCheckinLogEvent: undefined,
        otherUsersDataSources: undefined
    }],
    satelliteNow: 0,
    loading: true
};

// tslint:disable-next-line:only-arrow-functions
export function satelliteSurveillanceStateReducer(state = initialSatelliteSurveillanceValue,
                                                  action: ActionType<any>): SatelliteSurveillanceState {

    if (isAction(action as ActionType<Array<any>>, SatelliteSurveillanceActions.GET_SATELLITE_SURVEILLANCE_SUCCESS)) {

        return {
            ...state,
            satelliteSurveillance: (action as ActionType<any>).payload.satellites as Array<any>,
            satelliteNow: (action as ActionType<any>).payload.now,
            loading: false
        };
    }

    if (isAction(action as ActionType<Array<any>>, SatelliteSurveillanceActions.GET_SATELLITE_SURVEILLANCE_FAIL)
        || isAction(action as ActionType<Array<any>>, SatelliteSurveillanceActions.GET_SATELLITE_OTHER_DETAILS_FAIL)
    ) {
        return state;
    }

    if (isAction(action as ActionType<Array<any>>, SatelliteSurveillanceActions.GET_SATELLITE_OTHER_DETAILS_SUCCESS)) {
        // TODO: Consider switching to use NgRx-data or entity and create a sub selector that selects the part of the state that holds the single satellite item and then replace with a new that has the fetched values

        const satellites = [];
        state.satelliteSurveillance.forEach(satellite => {
            if (satellite.satelliteId === action.payload.satelliteId) {
                // Create new rather than mutating state
                const cloneSatellite = {
                    ...satellite,
                    lastCheckinLogEvent: action.payload.lastCheckinData,
                    otherUsersDataSources: action.payload.otherUsersDataSources
                };

                if (cloneSatellite.lastCheckinLogEvent !== undefined
                    && cloneSatellite.lastCheckinLogEvent !== null &&
                    cloneSatellite.lastCheckinLogEvent.latestCheckin !== undefined) {

                    const now = new Date().getTime();
                    const latestCheckin = Math.floor(cloneSatellite.lastCheckinLogEvent.latestCheckin);
                    let howLongAgo = now - latestCheckin;
                    const checkinInterval = Math.floor(cloneSatellite.lastCheckinLogEvent.checkinInterval);

                    // TODO: Switch to use localised strings placing days, hours, minutes via formatting in string

                    if (howLongAgo > checkinInterval) {
                        cloneSatellite.typeOfCheck = 'unresponsive';
                    } else {
                        cloneSatellite.typeOfCheck = 'next';
                        howLongAgo = checkinInterval - howLongAgo;

                    }

                    howLongAgo = Math.floor(howLongAgo / 1000);
                    cloneSatellite.howLongAgoLastCheckIn = howLongAgo;
                }

                satellites.push(cloneSatellite);

            } else {
                satellites.push(satellite);
            }
        }


        /*

        state.satelliteSurveillance.forEach(satellite => {
                satellite.lastCheckinLogEvent = satellite.satelliteId === action.payload.satelliteId
                    ? action.payload.lastCheckinLogEvent.lastCheckinLogEvent
                    : satellite.lastCheckinLogEvent;

                satellite.otherUsersDataSources = satellite.satelliteId === action.payload.satelliteId
                    ? action.payload.otherUsersDataSources
                    : satellite.otherUsersDataSources;

                if (satellite.lastCheckinLogEvent !== undefined && satellite.lastCheckinLogEvent !== null) {
                    if (satellite.lastCheckinLogEvent.latestCheckin !== undefined) {

                        const now = new Date().getTime();
                        const latestCheckin = Math.floor(satellite.lastCheckinLogEvent.latestCheckin);
                        let howLongAgo = now - latestCheckin;
                        const checkinInterval = Math.floor(satellite.lastCheckinLogEvent.checkinInterval);

                        // TODO: Switch to use localised strings placing days, hours, minutes via formatting in string

                        if (howLongAgo > checkinInterval) {
                            satellite.typeOfCheck = 'unresponsive';
                        } else {
                            satellite.typeOfCheck = 'next';
                            howLongAgo = checkinInterval - howLongAgo;

                        }

                        howLongAgo = Math.floor(howLongAgo / 1000);
                        satellite.howLongAgoLastCheckIn = howLongAgo;

                    }
                }
            }*/
        );

        return {
            ...state,
            satelliteSurveillance: satellites, // state.satelliteSurveillance,
            satelliteNow: state.satelliteNow,
            loading: false
        };
    }

    return state;
}
